"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_redux_1 = require("react-redux");
var pp_react_1 = require("@paypalcorp/pp-react");
var spinner_component_1 = require("../../components/spinner.component");
var interpolate_component_1 = require("../../components/interpolate-component");
var inputs_component_1 = require("../../components/inputs.component");
var interpolate_1 = require("../../utils/interpolate/interpolate");
var ajax_util_1 = require("../../utils/ajax/ajax.util");
var constants_1 = require("../../constants");
var ROUTES = constants_1.default.ROUTES, VIEWS = constants_1.default.VIEWS;
var commonweb_utils_1 = require("commonweb-utils");
var REDIRECT_TIMEOUT = 3000;
/**
 * CookiePref component
 */
var CookiePrefs = /** @class */ (function (_super) {
    tslib_1.__extends(CookiePrefs, _super);
    function CookiePrefs(props) {
        var _this = _super.call(this, props) || this;
        _this.inputChangedHandler = function (event, inputIdentifier) {
            var updatedForm = tslib_1.__assign({}, _this.state.form);
            var updatedFormElement = tslib_1.__assign({}, updatedForm[inputIdentifier]);
            updatedFormElement.value = event.target.checked;
            updatedFormElement.isTouched = true;
            updatedForm[inputIdentifier] = updatedFormElement;
            var formIsValid = true;
            for (var inputIdentifier_1 in updatedForm) {
                formIsValid = updatedForm[inputIdentifier_1].isValid && formIsValid;
            }
            _this.setState({ form: updatedForm, formIsValid: formIsValid });
        };
        _this.submitHandler = function (event) {
            event.preventDefault();
            if (!_this.state.formSubmitted) {
                var formData = {};
                for (var formElementIdentifier in _this.state.form) {
                    formData[formElementIdentifier] = _this.state.form[formElementIdentifier].value;
                }
                ajax_util_1.default.post$(_this.props.dispatch, _this.props._csrf, "" + ROUTES.API.COOKIE_PREFS.UPDATE, formData, { component: { name: VIEWS.COOKIES } }).then(function (response) {
                    _this.setState({ formMessage: _this.props.cookieContent.successMsg, formIsValid: true, formSubmitted: true });
                    setTimeout(function () {
                        _this.props.transitionOutHandler();
                        window.location = response.redirect;
                        return;
                    }, REDIRECT_TIMEOUT);
                }).catch(function (error) {
                    _this.setState({ formMessage: _this.props.commonContent.genericSettingsError, formIsValid: false });
                    return;
                });
            }
        };
        var cookieContent = props.cookieContent, cookiePrefs = props.cookiePrefs;
        _this.state = {
            form: {
                marketing: {
                    elementType: 'checkbox',
                    // if state value is true, then make it true, else false
                    value: cookiePrefs.marketing == true,
                    elementConfig: {
                        label: cookieContent.marketing,
                        helperText: cookieContent.marketingDesc,
                        labelClass: 'md',
                        labelSize: { medium: true }
                    },
                    validation: {
                        required: false
                    },
                    isValid: true,
                    isTouched: false
                },
                performance: {
                    elementType: 'checkbox',
                    // if state value is null, then make it pre-checked
                    // else mark is as it is in state
                    value: !(cookiePrefs.performance == false),
                    elementConfig: {
                        label: cookieContent.performance,
                        helperText: cookieContent.performanceDesc,
                        labelClass: 'md',
                        labelSize: { medium: true }
                    },
                    validation: {
                        required: false
                    },
                    isValid: true,
                    isTouched: false
                },
                functional: {
                    elementType: 'checkbox',
                    // if state value is null, then make it pre-checked
                    // else mark is as it is in state
                    value: !(cookiePrefs.functional == false),
                    elementConfig: {
                        label: cookieContent.functional,
                        helperText: cookieContent.functionalDesc,
                        labelClass: 'md',
                        labelSize: { medium: true },
                    },
                    validation: {
                        required: false
                    },
                    isValid: true,
                    isTouched: false
                },
                locale: {
                    isHidden: true,
                    elementConfig: {},
                    value: commonweb_utils_1.objectUtils.safeGet(props, 'locality.country') || ''
                },
                refererUrl: {
                    isHidden: true,
                    elementConfig: {},
                    value: commonweb_utils_1.objectUtils.safeGet(props, 'pageInfo.referringUrl') || ''
                },
                decodedReturnUrl: {
                    isHidden: true,
                    elementConfig: {},
                    value: cookiePrefs.decodedReturnUrl
                }
            },
            formIsValid: true,
            formSubmitted: false,
            formMessage: ''
        };
        return _this;
    }
    CookiePrefs.prototype.render = function () {
        var _this = this;
        var showSpinner = this.props.ui.showSpinner, cookieContent = this.props.cookieContent, cookiesFpti = this.props.cookiesFpti, formElementsArray = [], showSaveButton = false, form;
        for (var key in this.state.form) {
            formElementsArray.push({
                id: key,
                config: this.state.form[key]
            });
            showSaveButton = this.state.form[key].isTouched || showSaveButton;
        }
        form = (React.createElement("form", { onSubmit: this.submitHandler },
            this.state.formMessage ?
                React.createElement(pp_react_1.Alert, { className: "cookieAlert", type: this.state.formIsValid ? 'success' : 'error' }, this.state.formMessage) :
                null,
            React.createElement(pp_react_1.Text, { size: "xl3", className: "cookieTitle" }, this.props.isOnConfirmPage ? cookieContent.title : cookieContent.manageCookieTitle),
            React.createElement(pp_react_1.Text, { size: "md", medium: true, className: "cookieDevice" }, interpolate_1.default('inHTMLData', cookieContent.deviceInfo, { browserName: this.props.browserName })),
            React.createElement(pp_react_1.Text, { size: "md", className: "cookieConsentMsg" }, this.props.isOnConfirmPage ? cookieContent.consentMsg : cookieContent.manageConsentMsg),
            formElementsArray
                .filter(function (element) { return !element.config.isHidden; })
                .map(function (formElement) { return (React.createElement(React.Fragment, { key: formElement.id },
                React.createElement(pp_react_1.Container, { fluid: true, className: "cookiePrefPanel" },
                    React.createElement(pp_react_1.Row, null,
                        React.createElement(inputs_component_1.default, { key: formElement.id, id: formElement.id, className: formElement.id, elementType: formElement.config.elementType, elementConfig: formElement.config.elementConfig, value: formElement.config.value, changed: function (event) { return _this.inputChangedHandler(event, formElement.id); } })),
                    React.createElement(pp_react_1.Row, null,
                        React.createElement(pp_react_1.Text, { size: "md", className: "cookiePanelDesc alignLeft" }, formElement.config.elementConfig.helperText))),
                React.createElement(pp_react_1.Divider, null))); }),
            React.createElement(pp_react_1.Container, { fluid: true, className: "essentialPrefPanel" },
                React.createElement(pp_react_1.Row, null,
                    React.createElement(pp_react_1.Icon, { name: "lock", size: "sm" }),
                    React.createElement(pp_react_1.Text, { size: "md", medium: true, className: "essentialCookieTitle" }, cookieContent.essential)),
                React.createElement(pp_react_1.Row, null,
                    React.createElement(pp_react_1.Text, { size: "md", className: "cookiePanelDesc alignLeft" }, cookieContent.essentialDesc))),
            React.createElement(pp_react_1.Divider, null),
            React.createElement("div", { className: "cookieInfo" },
                React.createElement(pp_react_1.Text, { size: "lg", medium: true, className: "alignLeft" }, cookieContent.cookieHelpTitle),
                React.createElement(pp_react_1.Text, { size: "md", className: "cookieDesc alignLeft" }, this.props.cookieStatementComponent)),
            (showSaveButton || this.props.isOnConfirmPage) ?
                React.createElement("div", { className: "cookieAction" },
                    React.createElement(pp_react_1.Button, { name: cookiesFpti.submit, className: "test_submit" }, this.props.isOnConfirmPage ? cookieContent.confirmCookie : cookieContent.saveCookieSettings))
                : null));
        return (React.createElement("div", { className: "generic-container" }, showSpinner ? React.createElement(spinner_component_1.default, null) : form));
    };
    return CookiePrefs;
}(React.Component));
var mapStateToProps = function (_a) {
    var _csrf = _a._csrf, ui = _a.ui, content = _a.content, route = _a.route, cookiePrefs = _a.cookiePrefs, pageInfo = _a.pageInfo, links = _a.links, user = _a.user, fpti = _a.fpti;
    var browserName = pageInfo.browserName, cookieContent = content.cookiePrefs, commonContent = content.common, isOnConfirmPage = cookiePrefs.marketing == null && cookiePrefs.functional == null && cookiePrefs.performance == null, protectDataLink = user.type === 'BUSINESS' ?
        links.cookiePrefMoreInfoBusiness : links.cookiePrefMoreInfo, cookiesFpti = fpti.cookies, dataLinkComponent = React.createElement(pp_react_1.Link, { "data-name": cookiesFpti.protectData, key: cookieContent.protectYourDataLink, href: protectDataLink.linkUrl, target: protectDataLink.target }, cookieContent.protectYourDataLink), cookieLinkComponent = React.createElement(pp_react_1.Link, { "data-name": cookiesFpti.cookieStmt, key: cookieContent.cookieStatementLink, href: links.cookieStatement.linkUrl, target: links.cookieStatement.target }, cookieContent.cookieStatementLink), cookieStatementComponent = interpolate_component_1.InterpolateLinksWithComponent(cookieContent.cookieHelpDesc, [dataLinkComponent, cookieLinkComponent]);
    return {
        _csrf: _csrf,
        ui: ui,
        cookieContent: cookieContent,
        commonContent: commonContent,
        route: route,
        cookiePrefs: cookiePrefs,
        isOnConfirmPage: isOnConfirmPage,
        browserName: browserName,
        cookiesFpti: cookiesFpti,
        cookieStatementComponent: cookieStatementComponent
    };
};
function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch
    };
}
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(CookiePrefs);
